// extracted by mini-css-extract-plugin
export default {"device-buttons":"pDtQF","device-buttons__container":"dB56w"};